export default {
  "content": "<path d=\"M8 11h8V4h2v16h-2v-7H8v7H6V4h2v7zM4 18H2v-5H1v-2h1V6h2v12zM22 11h1v2h-1v5h-2V6h2v5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};